const _excluded = ["_dispatch"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { changeCompose, submitCompose, clearComposeSuggestions, fetchComposeSuggestions, selectComposeSuggestion, changeComposeSpoilerText, insertEmojiCompose, uploadCompose, detectLanguage } from 'soapbox/actions/compose';
import { getFeatures } from 'soapbox/utils/features';
import ComposeForm from '../components/compose_form';
const mapStateToProps = state => {
  const instance = state.get('instance');
  const now = new Date().getTime();
  return {
    text: state.getIn(['compose', 'text']),
    suggestions: state.getIn(['compose', 'suggestions']),
    spoiler: state.getIn(['compose', 'spoiler']),
    spoilerText: state.getIn(['compose', 'spoiler_text']),
    spoilerForced: state.getIn(['compose', 'spoiler_forced']),
    privacy: state.getIn(['compose', 'privacy']),
    focusDate: state.getIn(['compose', 'focusDate']),
    caretPosition: state.getIn(['compose', 'caretPosition']),
    hasPoll: !!state.getIn(['compose', 'poll']),
    isSubmitting: state.getIn(['compose', 'is_submitting']),
    isEditing: state.getIn(['compose', 'id']) !== null,
    isChangingUpload: state.getIn(['compose', 'is_changing_upload']),
    isUploading: state.getIn(['compose', 'is_uploading']),
    showSearch: state.getIn(['search', 'submitted']) && !state.getIn(['search', 'hidden']),
    anyMedia: state.getIn(['compose', 'media_attachments']).size > 0,
    isModalOpen: Boolean(state.get('modals').size && state.get('modals').last().modalType === 'COMPOSE'),
    maxTootChars: state.getIn(['instance', 'configuration', 'statuses', 'max_characters']),
    scheduledAt: state.getIn(['compose', 'schedule']),
    // we only want to keep scheduled status that werent sent, since server does not push that information to client when scheduled status are posted
    scheduledStatus: state.get('scheduled_statuses').filter(s => new Date(s.scheduled_at).getTime() > now),
    features: getFeatures(instance),
    conversationsMounted: state.getIn(['conversations', 'mounted'])
  };
};
const mapDispatchToProps = (dispatch, {
  intl
}) => ({
  onChange(text) {
    dispatch(changeCompose(text));
    dispatch(detectLanguage);
  },
  _dispatch: dispatch,
  onClearSuggestions() {
    dispatch(clearComposeSuggestions());
  },
  onFetchSuggestions(token) {
    dispatch(fetchComposeSuggestions(token));
  },
  onSuggestionSelected(position, token, suggestion, path) {
    dispatch(selectComposeSuggestion(position, token, suggestion, path));
  },
  onChangeSpoilerText(checked) {
    dispatch(changeComposeSpoilerText(checked));
  },
  onPaste(files) {
    dispatch(uploadCompose(files, intl));
  },
  onPickEmoji(position, data, needsSpace) {
    dispatch(insertEmojiCompose(position, data, needsSpace));
  }
});
function mergeProps(stateProps, dispatchProps, ownProps) {
  const {
      _dispatch: dispatch
    } = dispatchProps,
    restDispatchProps = _objectWithoutProperties(dispatchProps, _excluded);
  const defaultOnSubmit = async (router, _group) => {
    await dispatch(submitCompose(false));
  };
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, stateProps), restDispatchProps), ownProps), {}, {
    onSubmit: ownProps.onSubmit ?? defaultOnSubmit
  });
}
export default injectIntl(connect(mapStateToProps, mapDispatchToProps, mergeProps)(ComposeForm));